export default {
    READY: 'ready',
    UPLOADING: 'uploading',
    FAIL: 'fail',
    SUCCESS: 'success'
};
